import React, { Component } from "react";
import { Card, Container, Button, InputGroup } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faPlusCircle, faRecycle, faSlash, faUserEdit } from "@fortawesome/free-solid-svg-icons";

import SubscriberGrid from "./SubscriberGrid.jsx";
import ModalNewSubscriberDialog from "./ModalNewSubscriberDialog";

import GlasschainHttpClient from "providers/http/GlasschainMsaHttpClient.js";



const DelSwal = withReactContent(Swal);


export default class SubscriberPanel extends Component {
  constructor(props) {
    super(props);

    //this.localDataService = new LocalDataService();
    this.coreService = new GlasschainHttpClient();

    this.syncTimer = null;

    this.state = {
      editMode: "add",
      subscriberData: null,
      currentSubscriber: null,
      isLoadingGrid: false,
      notificationDocuments: null,
      notificationDocs: null
    };

    this.refreshNotificationDocData = this.refreshNotificationDocData.bind(this);
    this.refreshSubscriberData = this.refreshSubscriberData.bind(this);
    this.onSubscriberRowSelectChange = this.onSubscriberRowSelectChange.bind(this);
    this.onNewSubscriberRequest = this.onNewSubscriberRequest.bind(this);
    this.onEditSubscriberRequest = this.onEditSubscriberRequest.bind(this);
    this.onDeleteSubscriberRequest = this.onDeleteSubscriberRequest.bind(this);

    this.closeNewSubscriberModal = this.closeNewSubscriberModal.bind(this);
    this.postNewSubscriber = this.postNewSubscriber.bind(this);
    this.postUpdatedSubscriber = this.postUpdatedSubscriber.bind(this);
    this.onDeleteSubscriberRequest = this.onDeleteSubscriberRequest.bind(this);

  }

  async componentDidMount() {
    await this.refreshAllData();
  }


  async refreshAllData() {
    await this.refreshSubscriberData();
    await this.refreshNotificationDocData();
  }

  async refreshSubscriberData() {
    this.setState({ isLoadingGrid: true });
    var subscriberDataResult = await this.coreService.fetchSubscribers();
    console.log("Subscriber Data:");
    console.info(subscriberDataResult);
    this.setState({
      subscriberData: subscriberDataResult,
      selectedSubscriberRow: null, // reset
      isLoadingGrid: false,
      syncing: false,
    });
  }

  async refreshNotificationDocData() {
    var notificationDocsResult = await this.coreService.fetchDocuments();
    this.setState({ notificationDocs: notificationDocsResult });
  }


  onSubscriberRowSelectChange(newSelectedSubscriberRow) {
    console.log("OnSubscriberRowSelectChange");
    console.log("set state for selectedSubscriberRow");
    console.info(newSelectedSubscriberRow);
    this.setState({ currentSubscriber: newSelectedSubscriberRow });
  }

  onNewSubscriberRequest() {
    this.setState({
      editMode: "add",
      showNewSubModal: true
    });
  }

  onEditSubscriberRequest() {
    this.setState({
      editMode: "update",
      showNewSubModal: true
    });
  }

  closeNewSubscriberModal() {
    this.setState({ showNewSubModal: false })
  }

  async postNewSubscriber(subscriber) {
    var result = await this.coreService.postSubscriber(subscriber);
    this.closeNewSubscriberModal();
    toast.success("New subscriber " + subscriber.name + " has been added.");
    await this.refreshSubscriberData();
  }

  async postUpdatedSubscriber(subscriber) {
    var result = await this.coreService.postSubscriber(subscriber);
    this.closeNewSubscriberModal();
    toast.success("subscriber " + subscriber.name + " has been updated.");
    await this.refreshSubscriberData();
  }

  async onDeleteSubscriberRequest() {
    if (!this.state.currentSubscriber) {
      DelSwal.fire({ icon: "error", title: "Remove Subscriber", text: "Select a subscriber to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove Subscriber?",
          text: "Confirm you want to permanently remove the existing subscriber " + this.state.currentSubscriber.name,
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          await this.coreService.postSubscriberDeleteRequest(this.state.currentSubscriber.id);
          toast.success("Subscriber " + this.state.currentSubscriber.name + " has been removed from subscriptions.")
          await this.refreshSubscriberData();
        }
      }
      );
  }



  render() {

    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );


    return (
      <div id="admin-panel">

        <div>
          <ModalNewSubscriberDialog
            showNewSubscriberModal={this.state.showNewSubModal}
            closeNewSubscriberModal={this.closeNewSubscriberModal}
            postNewSubscriber={this.postNewSubscriber}
            postUpdatedSubscriber={this.postUpdatedSubscriber} 
            notificationDocs={this.state.notificationDocs}
            userSession={this.props.userSession}
            editMode={this.state.editMode}
            currentSubscriber={this.state.currentSubscriber}
          />
        </div>

        <h3 style={{ color: "black", marginLeft: "10px" }}>Notification Subscribers</h3>

        <div id="adminselectionui">

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onNewSubscriberRequest}
          >
            <FontAwesomeIcon icon={faPlusCircle} />
            &nbsp;New
          </Button>

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onEditSubscriberRequest}
          >
            <FontAwesomeIcon icon={faUserEdit} />
            &nbsp;Edit
          </Button>

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onDeleteSubscriberRequest}
          >
            <FontAwesomeIcon icon={faSlash} />
            &nbsp;Delete
          </Button>

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.refreshSubscriberData}
          >
            <FontAwesomeIcon icon={faRecycle} />
            &nbsp;Refresh
          </Button>

          <span style={{ float: "right", paddingLeft: "20px", paddingRight: "20px" }}>{loadingGridIcon}</span>
        </div>

        <div style={{ width: "100%", height: "100%" }}>
          <SubscriberGrid
            rowData={this.state.subscriberData}
            onSubscriberRowSelectChange={this.onSubscriberRowSelectChange}
            onEditSubscriberRequest={this.onEditSubscriberRequest}
          />
        </div>

      </div>
    );
  }
}
